export default "__VITE_ASSET__DVDelwEo__"